import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const SermorelinPage10: React.FC = () => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const navigate = useNavigate();

  const options = [
    "Yes, I binge drink (4-5+ drinks on occasion per CDC guidelines)",
    "Yes, I use opiate medications routinely",
    "I do both",
    "None of the above",
  ];

  const handleOptionClick = (option: string) => {
    let newSelection = [...selectedOptions];

    if (option === "None of the above") {
      newSelection = ["None of the above"];
    } else if (option === "I do both") {
      newSelection = ["I do both"];
    } else {
      // Remove "None of the above" and "I do both" if any
      newSelection = newSelection.filter(
        (opt) => opt !== "None of the above" && opt !== "I do both"
      );

      // Toggle selection
      if (newSelection.includes(option)) {
        newSelection = newSelection.filter((opt) => opt !== option);
      } else {
        newSelection.push(option);
      }
    }

    setSelectedOptions(newSelection);
  };

  useEffect(() => {
    const step9Completed = localStorage.getItem("completed-step-9");
    if (step9Completed) {
      navigate("/sermorelin/getting-started/step-10", { replace: true });
    } else {
      navigate("/sermorelin/getting-started/step-9", { replace: true });
    }
  }, []);

  useEffect(() => {
    const savedData = localStorage.getItem(
      "Do_you_use_opiate_medications_routinely_or_binge_drink_alcohol"
    );
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        const value = parsed?.value;
        const normalizedValue = Array.isArray(value)
          ? value
          : typeof value === "string"
          ? [value]
          : [];
        setSelectedOptions(normalizedValue);
      } catch (err) {
        console.error("Invalid localStorage data:", err);
        setSelectedOptions([]);
      }
    }
  }, []);

  const handleNext = () => {
    if (selectedOptions.length > 0) {
      localStorage.setItem(
        "Do_you_use_opiate_medications_routinely_or_binge_drink_alcohol",
        JSON.stringify({
          key: "Do_you_use_opiate_medications_routinely_or_binge_drink_alcohol",
          value: selectedOptions,
        })
      );
      localStorage.setItem("completed-step-10", "true");
      if(!selectedOptions.includes("None of the above")){
        navigate("/sermorelin/disqualified");
      }else {
      navigate("/sermorelin/getting-started/step-11");
      }
    }
  };

  const handleBack = () => {
    navigate("/sermorelin/getting-started/step-9");
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={75} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
          Do you use opiate medications routinely or binge drink alcohol?
          </p>
          <div className="signup-options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOptions.includes(option) ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>

          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={selectedOptions.length === 0}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SermorelinPage10;
